/**
 * 商品总计
 */
import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import { Calculator, format2Decimal, parseYuan2Currency } from '@/utils/number';
import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import DiffContent from '@/components/Order/DiffContent';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reversal/goods';

import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { goodsList } = state;
  return { goodsList };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { goodsList } = props;

  const summaryInfo = useMemo(() => {
    const prevCount = new Calculator(); // 调整商品数量
    const prevValue = new Calculator();
    const currentCount = new Calculator();
    const currentValue = new Calculator();
    if (goodsList && goodsList.length) {
      goodsList.forEach((item) => {
        prevCount.plus(item.initCount);
        prevValue.plus(item.initTotalValue);
        currentCount.plus(item.currentCount);
        currentValue.plus(item.currentTotalValue);
      });
    }
    return {
      prevGoodsCount: prevCount.getValue(),
      prevGoodsValue: format2Decimal(prevValue.getValue()),
      currentGoodsCount: currentCount.getValue(),
      currentGoodsValue: format2Decimal(currentValue.getValue()),
    };
  }, [goodsList]);

  // 价格
  const renderPrice = (val) => {
    return parseYuan2Currency(val);
  };

  return (
    <ContentBlock
      title={intl.get('reversal_goods_summary_block_title')}
      className={styles.summaryBlock}
    >
      <FormItem label={intl.get('reversal_goods_summary_count_label')}>
        <DiffContent
          preValue={summaryInfo.prevGoodsCount}
          currentValue={summaryInfo.currentGoodsCount}
        />
      </FormItem>
      <br />
      <FormItem label={intl.get('reversal_goods_summary_amount_label')}>
        <DiffContent
          preValue={renderPrice(summaryInfo.prevGoodsValue)}
          currentValue={renderPrice(summaryInfo.currentGoodsValue)}
        />
      </FormItem>
    </ContentBlock>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
